import { Link } from 'react-router-dom'
import { useHealth } from '../api/use-health'
import { Term } from '../components/Term'

export function Landing() {
  const { health } = useHealth()
  return (
    <div className="max-w-3xl mx-auto py-8">
      <h1 className="text-2xl sm:text-3xl font-semibold text-text mb-4">Sezi</h1>
      <p className="text-text-dim mb-4 text-base leading-relaxed">
        Sezi, kontrastlı meme MR görüntülerini otomatik olarak inceleyen bir araştırma
        prototipidir. Verilen görüntüdeki lezyonu bulur, 3B yüzey modelini çıkarır ve
        lezyonun{' '}
        <Term id="iyi-huylu-kotu-huylu">iyi huylu mu yoksa kötü huylu mu</Term>{' '}
        olabileceğine dair bir olasılık tahmini üretir.
      </p>
      <p className="text-text-dim mb-6 text-base leading-relaxed">
        Bu prototip, Başkent Üniversitesi bünyesinde proje çalışması olarak
        geliştirilmiştir. Klinik kullanım için tasarlanmamıştır.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8">
        <Stage num={1} label="Segmentasyon" desc="Lezyon sınırlarının çıkarılması" />
        <Stage num={2} label="3B yüzey" desc="Pürüzsüz üç boyutlu model" />
        <Stage num={3} label="Sınıflandırma" desc="İyi huylu / kötü huylu olasılığı" />
      </div>

      <div className="flex gap-3 mb-10 flex-wrap">
        <Link
          to="/cases"
          className="px-4 py-2 bg-accent text-accent-fg rounded font-medium no-underline hover:opacity-90"
        >
          Demo vakaları görüntüle →
        </Link>
        <Link
          to="/hakkinda"
          className="px-4 py-2 bg-surface-2 text-text border border-border rounded no-underline hover:bg-surface"
        >
          Sezi nasıl çalışır?
        </Link>
        {health?.mode === 'live' && (
          <Link
            to="/upload"
            className="px-4 py-2 bg-surface-2 text-text border border-border rounded no-underline hover:bg-surface"
          >
            Kendi görüntünü yükle
          </Link>
        )}
      </div>

      <section className="border border-border rounded p-4 bg-surface mb-6">
        <h2 className="font-medium text-text mb-2">İki tamamlayıcı model</h2>
        <ul className="text-sm text-text-dim space-y-2">
          <li>
            <strong className="text-text">AMBL modeli.</strong> Yalnızca{' '}
            <Term id="ambl">AMBL</Term> veri kümesi üzerinde eğitilmiştir. AMBL’ye
            benzer protokolde çekilmiş görüntülerde en iyi sonucu verir; farklı{' '}
            <Term id="kohort">kohortlarda</Term> doğrulanmamıştır.
          </li>
          <li>
            <strong className="text-text">Kombine model.</strong>{' '}
            <Term id="ambl">AMBL</Term> ve <Term id="bd">BREAST-DIAGNOSIS</Term>{' '}
            kümeleri birleştirilerek eğitilmiştir. Farklı kaynaklardan gelen
            görüntülerde daha tutarlı davranır; AMBL’deki doğruluğu biraz daha düşüktür.
          </li>
        </ul>
        <p className="text-xs text-text-dim mt-3">
          Vaka sayfasında iki modelin sonucu yan yana gösterilir. Detaylı açıklama
          için <Link to="/hakkinda#iki-model" className="text-accent">Hakkında sayfasına</Link>{' '}
          bakabilirsiniz.
        </p>
      </section>

      <section className="border border-warn/40 rounded p-4 bg-warn/5">
        <h2 className="font-medium text-warn mb-2">Sorumluluk reddi</h2>
        <p className="text-sm text-text-dim">
          Sezi’nin ürettiği hiçbir çıktı tıbbi tavsiye değildir ve klinik tanı veya tedavi
          kararlarında kullanılamaz. Modelin bilinen sınırlamaları{' '}
          <Link to="/hakkinda#sinirlamalar" className="text-accent">
            Hakkında sayfasında
          </Link>{' '}
          listelenmiştir. Şüpheli bir bulgu durumunda her zaman yetkili bir hekime
          başvurunuz.
        </p>
      </section>
    </div>
  )
}

function Stage({ num, label, desc }: { num: number; label: string; desc: string }) {
  return (
    <div className="border border-border rounded p-3 bg-surface">
      <div className="text-xs text-text-dim mb-1">Adım {num}</div>
      <div className="text-text font-medium">{label}</div>
      <div className="text-xs text-text-dim">{desc}</div>
    </div>
  )
}
